/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
import * as __WEBPACK_EXTERNAL_MODULE__api_client_mjs_6a0489f6__ from "./api-client.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__config_mjs_e81460ea__ from "./config.mjs";
var __webpack_exports__BingSearchClient = __WEBPACK_EXTERNAL_MODULE__api_client_mjs_6a0489f6__.BingSearchClient;
var __webpack_exports__getBingSearchConfig = __WEBPACK_EXTERNAL_MODULE__config_mjs_e81460ea__.getBingSearchConfig;
export { __webpack_exports__BingSearchClient as BingSearchClient, __webpack_exports__getBingSearchConfig as getBingSearchConfig };
